'use strict'

export function isEscape(event) {
    let result = false;
    if ("key" in event) {
        result = (event.key === "Escape" || event.key === "Esc");
    } else {
        result = (event.keyCode === 27);
    }
    return result;
}
